// extracted by mini-css-extract-plugin
export default {"container":"ZY-z","list":"_Y-z"};